import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, Search } from "lucide-react";

export default function Audit() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState({ action: "", resource_type: "" });
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    const params = new URLSearchParams();
    Object.entries(filter).forEach(([k, v]) => v && params.set(k, v));
    params.set("limit", "300");
    const { data } = await api.get(`/api/admin/audit?${params.toString()}`);
    setItems(data); setBusy(false);
  };
  useEffect(() => { load(); }, [filter]);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div className="text-[var(--text-2)] text-sm">Immutable trail of every privileged action. Append-only.</div>

      <div className="flex gap-3">
        <div className="relative flex-1">
          <Search size={14} className="absolute left-3 top-3 text-[var(--text-3)]"/>
          <input value={filter.action} onChange={(e) => setFilter({ ...filter, action: e.target.value })}
                 placeholder="Search actions…"
                 className="w-full pl-9 pr-3 py-2 bg-[var(--surface)] border border-[var(--border)] rounded text-sm focus:outline-none focus:border-[var(--gold)]" data-testid="audit-search"/>
        </div>
        <select value={filter.resource_type} onChange={(e) => setFilter({ ...filter, resource_type: e.target.value })}
                className="px-3 py-2 bg-[var(--surface)] border border-[var(--border)] rounded text-sm" data-testid="audit-resource-filter">
          <option value="">All resources</option>
          {["user", "operator", "provider", "game", "settlement", "webhook", "wallet"].map(r => <option key={r} value={r}>{r}</option>)}
        </select>
      </div>

      <div className="card-surface overflow-hidden">
        <div className="overflow-x-auto max-h-[70vh]">
          <table className="aggr-table">
            <thead><tr><th>When</th><th>Actor</th><th>Action</th><th>Resource</th><th>Resource ID</th><th>IP</th></tr></thead>
            <tbody>
              {busy && <tr><td colSpan={6} className="text-center py-6"><Loader2 className="inline animate-spin" size={14}/></td></tr>}
              {!busy && items.map(a => (
                <tr key={a.id}>
                  <td className="text-xs text-[var(--text-3)] font-mono">{new Date(a.created_at).toLocaleString()}</td>
                  <td className="text-xs">{a.actor_email}</td>
                  <td><span className="font-mono text-xs text-[var(--gold)]">{a.action}</span></td>
                  <td className="text-xs">{a.resource_type}</td>
                  <td className="font-mono text-xs">{a.resource_id}</td>
                  <td className="font-mono text-xs text-[var(--text-3)]">{a.ip || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
